module.exports = __webpack_public_path__ + "img/make-brushes-2_jp.dfd25ab.jpg";